"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroyLocalStorageLinkToken = destroyLocalStorageLinkToken;
exports.getLocalStorageLinkToken = getLocalStorageLinkToken;
exports.putLocalStorageLinkToken = putLocalStorageLinkToken;
var LINK_TOKEN = 'link_token';
function getLocalStorageLinkToken() {
  return localStorage.getItem(LINK_TOKEN);
}
function destroyLocalStorageLinkToken() {
  return localStorage.removeItem(LINK_TOKEN);
}
function putLocalStorageLinkToken(val) {
  if (val) {
    return localStorage.setItem(LINK_TOKEN, val);
  }
  return undefined;
}
